import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import { bootstrapLocale } from './i18n/bootstrapLocale'
import { loadUmami } from './analytics/loadUmami'
import App from './App.tsx'

function render() {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

// Waits for a possible server-suggested language (first-ever visit only, see bootstrapLocale) so
// the very first render already uses the right language instead of flashing German and switching.
bootstrapLocale().finally(render)

loadUmami()
